export default __webpack_public_path__ + "static/media/Coffees-hover.6c4a93b1.svg";